import React, { Component } from 'react';
import { Table, Input, Row, Col, Button, Modal, Popover } from 'antd'
import { EditOutlined, DeleteOutlined, PlusOutlined, PushpinOutlined } from '@ant-design/icons';
import { getRouteCustomer, sortCustomer } from '../../services/route';
import { withRouter } from 'react-router-dom';
import { deleteCustomer } from '../../services/customer';
import { DragSortTable } from '@ant-design/pro-components';

const { Search } = Input;
const confirm = Modal.confirm;

class CustomerList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            page: 1,
            pageSize: 10000,
            total: 10,
            sortBy: "route_order",
            sortDir: "ascend",
            q: "",
            dataLoading: false,
            disableSort: false,
            lat: undefined,
            lng: undefined,
        }

        this.getData = this.getData.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onPageSizeChange = this.onPageSizeChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onTableChange = this.onTableChange.bind(this);
        this.onRowEditClick = this.onRowEditClick.bind(this);
        this.onRowDeleteClick = this.onRowDeleteClick.bind(this);
        this.onCreateCustomerClicked = this.onCreateCustomerClicked.bind(this);
        this.handleDragSortEnd = this.handleDragSortEnd.bind(this);
        this.getWaypointsUrl = this.getWaypointsUrl.bind(this);
        this.getCurrentPosition = this.getCurrentPosition.bind(this);
    }

    onPageChange(page, pageSize) {
        this.setState({
            page: page,
            pageSize: pageSize
        }, () => {
            this.getData()
        })
    }

    onPageSizeChange(current, size) {
        this.setState({
            page: current,
            pageSize: size
        }, () => {
            this.getData()
        })
    }

    onTableChange(pagination, filters, sorter) {
        const { page, pageSize, sortBy, sortDir } = this.state
        this.setState({
            page: pagination['current'] || page,
            pageSize: pagination['pageSize'] || pageSize,
            sortBy: sorter['columnKey'] || sortBy,
            sortDir: sorter['order'] || sortDir,
        }, () => {
            this.getData()
        })
    };

    onSearch(value) {
        let disableSort = false;
        if (value !== ""){
            disableSort = true
        }
        this.setState({
            q: value,
            page: 1,
            disableSort
        }, () => {
            this.getData()
        })
    }

    async onNameClicked(row) {
        const { history, routeId } = this.props;
        history.push(`/routes/${routeId}/customer_detail/${row.id}`)
    }

    async getCurrentPosition(){
        await navigator.geolocation.getCurrentPosition(
            position=>this.setState({ lat: position.coords.latitude, lng: position.coords.longitude }))
    }

    async getData() {
        const { routeId } = this.props
        this.setState({
            dataLoading: true
        }, async () => {
            const { q, page, pageSize, sortBy, sortDir } = this.state
            let result = await getRouteCustomer(routeId, q, {}, page, pageSize, sortBy, sortDir)
            this.setState({
                data: result.data.customers,
                total: result.data.total,
                dataLoading: false
            })
        })
    }

    componentDidMount() {
        this.getData()
        this.getCurrentPosition()
    }

    async onRowEditClick(row) {
        const { history, routeId } = this.props;
        history.push(`/routes/${routeId}/customer_edit/${row.id}`)
    }

    onRowDeleteClick(row, onPageChange, page, pageSize) {
        confirm({
            title: `ต้องการลบ ${row.name} หรือไม่?`,
            okText: 'ตกลง',
            cancelText: 'ยกเลิก',
            async onOk() {
                let response = await deleteCustomer(row.id);
                if (response.status === 200) {
                    await onPageChange(page, pageSize);
                }
            },
            onCancel() { }
        });
    }

    async onCreateCustomerClicked() {
        const { history, routeId } = this.props;
        history.push(`/routes/${routeId}/customer_create`)
    }

    async handleDragSortEnd(beforeIndex, afterIndex, newDataSource) {
        const { routeId } = this.props;
        const orderIds = []
        for (let i = 0; i<newDataSource.length; i++){
            // newDataSource[i]['route_order'] = i+1
            orderIds.push(newDataSource[i].id)
        }
        const result = await sortCustomer(routeId, orderIds) 
        this.setState({
            data: newDataSource,
        })
    };

    getWaypointsUrl(row, rowInd, loops) {
        const { data, lat, lng } = this.state;
        let waypoints = "";
        let startRow = rowInd // Start waypoint
        let endRow = startRow + (loops - 1) // End waypoint according to loops (-1 because count from the startRow)
        if (endRow > data.length - 1){
            endRow = data.length - 1 // Prevent out of index
        }
        for (let i = startRow; i < endRow; i++){
            waypoints += `${data[i].lat},${data[i].lng}|`
        }
        // Remove the last |
        if (waypoints.charAt(waypoints.length - 1) === "|") {
            waypoints = waypoints.substring(0, waypoints.length - 1);
        }
        
        return `http://maps.google.co.th/maps/dir/?api=1&origin=${lat},${lng}&destination=${data[endRow].lat},${data[endRow].lng}&waypoints=${waypoints}&travelmode=driving`
    }

    render() {

        const { data, total, page, pageSize, dataLoading, disableSort } = this.state

        let tableColumns = [
            {
                title: 'ชื่อลูกค้า',
                dataIndex: 'name',
                key: 'name',
                // sorter: true,
                render: (text, row) => (
                    <a onClick={() => this.onNameClicked(row)}>{row.name}</a>
                )
            },
            {

                title: 'จำนวนถัง',
                dataIndex: 'total_bucket',
                key: 'total_bucket'
            },
            // {

            //     title: 'ราคาขาย',
            //     dataIndex: 'price',
            //     key: 'price',
            //     // sorter: true
            // },
            // {

            //     title: 'จำนวนกระสอบ',
            //     dataIndex: 'total_sack',
            //     key: 'total_sack'
            // },
            {

                title: 'นำทาง',
                dataIndex: 'navigate',
                key: 'navigate',
                render: (text, row, ind) => (
                    <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                        {/* <Popover content={
                                <div style={{display: 'flex', justifyContent: 'space-around'}}>
                                    <Button color="cyan" variant="solid" size="small" onClick={() => window.open(this.getWaypointsUrl(row, ind, 1), '_blank').focus()} style={{marginRight: 5}}>1 <PushpinOutlined /></Button>
                                    <Button color="pink" variant="solid" size="small" onClick={() => window.open(this.getWaypointsUrl(row, ind, 5), '_blank').focus()}>5 <PushpinOutlined /></Button>
                                </div>} 
                            title="" trigger="click"> */}
                            {/* <Button
                                color="primary"
                                variant="solid"
                                shape="circle"
                                size="small"
                                icon={<PushpinOutlined />}
                                // onClick={() => window.open(this.getWaypointsUrl(row, ind), '_blank').focus()}
                                // onClick={() => window.open(`http://maps.google.co.th/maps?q=${row.lat},${row.lng}`, '_blank').focus()}
                                style={{ marginRight: 5 }}
                            /> */}
                            <Button color="cyan" variant="solid" size="small" onClick={() => window.open(this.getWaypointsUrl(row, ind, 1), '_blank').focus()} style={{marginRight: 5}}>1 <PushpinOutlined /></Button>
                            <Button color="pink" variant="solid" size="small" onClick={() => window.open(this.getWaypointsUrl(row, ind, 5), '_blank').focus()}>5 <PushpinOutlined /></Button>
                        {/* </Popover> */}
                        
                    </div>
                )
            },
            {
                title: 'ตัวเลือก',
                dataIndex: 'action',
                key: 'action',
                render: (text, row) => (
                    <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                        <Button
                            color="default"
                            shape="circle"
                            size="small"
                            icon={<EditOutlined />}
                            onClick={() => this.onRowEditClick(row)}
                            style={{ marginRight: 5 }}
                        />
                        <Button
                            color="danger"
                            variant="solid"
                            shape="circle"
                            size="small"
                            icon={<DeleteOutlined />}
                            onClick={() => this.onRowDeleteClick(row, this.getData, page, pageSize)}
                        />
                    </div>
                )
            }
        ]

        if (!disableSort) {
            tableColumns = [
                {
                    title: 'เรียง',
                    dataIndex: 'sort',
                    className: 'drag-visible',
                }, 
                ...tableColumns];
        }

        return (
            <div>
                <Row>
                    <Col span={8} xs={6} sm={6} md={8} lg={8} xl={8} xxl={8}/>
                    <Col span={10} xs={12} sm={12} md={10} lg={10} xl={10} xxl={10}>
                        <Search
                            placeholder="ค้นหาด้วยชื่อ หรือเลขถัง"
                            onSearch={this.onSearch}
                        />
                    </Col>
                    <Col span={1} offset={5}>
                        <Button
                            style={{ float: 'right' }}
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => this.onCreateCustomerClicked()}
                        />
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col span={24}>
                        {/* <Table
                            rowKey={'id'}
                            columns={tableColumns}
                            dataSource={data}
                            bordered
                            locale={{ filterConfirm: 'OK', filterReset: 'รีเซ็ต', emptyText: 'ไม่พบข้อมูล' }}
                            pagination={{ current: page, pageSize: pageSize, total: total, showSizeChanger: true, pageSizeOptions: ['25', '50', '100', '200'] }}
                            loading={dataLoading}
                            onChange={this.onTableChange}
                        /> */}
                        <DragSortTable
                            columns={tableColumns}
                            rowKey="id"
                            search={false}
                            pagination={false}
                            dataSource={data}
                            dragSortKey="sort"
                            options={false}
                            onDragSortEnd={this.handleDragSortEnd}
                            locale={{ emptyText: 'ไม่มีข้อมูล' }}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default withRouter(CustomerList);